import React from "react";
import DataGrid from './data-grid';
import format from "../functions/format";
import Trend from "./trend";
export default class ActivityLocationPlacesGrid extends React.Component {
  render() {
    var data = this.props.data;
    var column = this.props.column;
    var comparison = this.props.comparison;
    var columns = [{
      field: 'name',
      title: 'Name',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.name));
      }
    }, {
      field: 'city',
      title: 'City',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.city));
      }
    }, {
      field: 'postalCode',
      title: 'Postal Code',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.postalCode));
      }
    }, {
      field: 'regionCode',
      title: 'Region',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.regionCode));
      }
    }, {
      field: 'views',
      title: 'Views',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x[column] === row[column]);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.views, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.views,
          data: row.views
        })));
      }
    }, {
      field: 'uniqueUsers',
      title: 'Unique Users',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x[column] === row[column]);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.uniqueUsers, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.uniqueUsers,
          data: row.uniqueUsers
        })));
      }
    }, {
      field: 'conversions',
      title: 'Conversions',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x[column] === row[column]);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.conversions, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.conversions,
          data: row.conversions
        })));
      }
    }, {
      field: 'engagements',
      title: 'Interactions',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x[column] === row[column]);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.engagements, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.engagements,
          data: row.engagements
        })));
      }
    }];
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}